import { Box } from '@chakra-ui/react';
import React from 'react';
import { useLocation } from 'react-router-dom';

const DataNotFound = ({ title }) => {
    const location = useLocation();

    const messages = {
        "crm/leads": "No Leads Found",
        "crm/contacts": "No Contacts Found",
        "crm/properties": "No Properties Found",
        "crm/tasks": "No Tasks Found",
        "crm/meeting": "No Meetings Found",
        "crm/phone-call": "No Calls Found",
        "crm/email": "No Emails Found",
        "crm/reporting-analytics": "No Reports Found",
        "password/my-password": "No Passwords Found",
        "password/share-with-me": "No Shared Passwords Found",
        "password/share-by-me": "No Shared Passwords Found",
        "recruitment/jobProfile": "No Jobs Found",
        "recruit/candidate": "No Candidates Found",
        "recruitment/interviews": "No Interviews Found",
        "organization/departments": "No Departments Found",
        "recruit/jobApplication": "No Job Applications Found",
        "recruitment/referrals": "No Referrals Found",
        "recruitment/offerLetter": "No Offer Letters Found"
    };

    const message = Object.keys(messages).find(path => location.pathname.includes(path));

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
            -- {title ? `No ${title} Found` : message ? messages[message] : "No Data Found"} --
        </Box>
    );
}

export default DataNotFound;
